import { PageTransition } from 'ionic-angular';

/**
 * Instant modal enter/leave. Ionic's default slide uses transform on
 * .modal-wrapper, which on some WebViews mis-hit-tests taps (keyboard /
 * search) and can crash WKWebView when extra GPU layers are present.
 */
export class ModalNoneTransition extends PageTransition {
  init() {
    super.init();
    this.duration(0);
    const view = this.enteringView || this.leavingView;
    if (!view || !view.pageRef) {
      return;
    }
    const ele = view.pageRef().nativeElement;
    const wrapper = ele.querySelector('.modal-wrapper');
    if (wrapper) {
      wrapper.style.webkitTransform = 'none';
      wrapper.style.transform = 'none';
      wrapper.style.opacity = '1';
    }
  }
}

export function safeModalOpts(extra?: any) {
  const opts: any = { enableBackdropDismiss: false };
  if (extra) {
    for (const key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) {
        opts[key] = extra[key];
      }
    }
  }
  return opts;
}



// WEBPACK FOOTER //
// ./src/util/modal-none-transition.ts